import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga4';
import { Route } from 'react-router-dom';
import config from '../config';

function GoogleAnalytics({ location, options }) {

    const logPageChange = useCallback((pathname, search = '') => {
        const page = pathname + search;
        const { location: windowLocation } = window;
        ReactGA.set({
            page,
            location: `${windowLocation.origin}${page}`,
            ...options
        });
        ReactGA.pageview(page);
        console.log({page})
    }, [options])

    useEffect(() => {
      const { pathname, search } = location;
      logPageChange(pathname, search);
    }, [location, logPageChange])

    return null;
}



GoogleAnalytics.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string
    }).isRequired,
    options: PropTypes.object
};

const RouteTracker = () => <Route component={GoogleAnalytics} />;

const init = (options = {}) => {
    const isGAEnabled = process.env.NODE_ENV === 'production';

    // if (isGAEnabled) {
        ReactGA.initialize(config.googleAnalyticsTrackingId);
    // }

    return isGAEnabled;
};

export default {
    GoogleAnalytics,
    RouteTracker,
    init
};